import { render, staticRenderFns } from "./PagoAfpModal.vue?vue&type=template&id=8ef3ed16"
import script from "./PagoAfpModal.vue?vue&type=script&lang=js"
export * from "./PagoAfpModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports